<template>
  <div class="bg-white dark:bg-gray-800 p-4 rounded-lg shadow">
    <div class="chart-container mx-auto p-4">
      <h3 class="text-lg font-semibold mb-4">Top 10 Usuários por Gastos</h3>
      <Bar :data="chartData" :options="chartOptions" :height="150" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { Bar } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

// Registrar os componentes necessários do Chart.js
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

const props = defineProps({
  usuarios_top10: {
    type: Array,
    required: true,
  },
});

// Dados do gráfico
const chartData = computed(() => ({
  labels: props.usuarios_top10
    .slice(0, 10)
    .map((user) =>
      user.titulo.length > 20 ? user.titulo.substring(0, 17) + "..." : user.titulo
    ),
  datasets: [
    {
      label: "Total Gasto (R$)",
      data: props.usuarios_top10.slice(0, 10).map((user) => parseFloat(user.total_gasto)),
      backgroundColor: "#42A5F5",
    },
  ],
}));

const chartOptions = {
  responsive: true,
  scales: { y: { beginAtZero: true } },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const value = context.parsed.y;
          return `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;
        },
        title: function (context) {
          const item = props.usuarios_top10[context[0].dataIndex];
          return `${item.titulo}`;
        },
      },
    },
  },
};

// Formatar valores monetários
const formatCurrency = (value) => {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);
};
</script>

<style scoped>
.chart-container {
  height: 300px;
  width: 100%;
}
</style>
